// Taxes canadiennes par province/territoire (taux 2026 — TVH Nouvelle-Écosse à 14 % depuis avril 2025)
export const PROVINCES = [
  { code: "QC", fr: "Québec", en: "Quebec", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }, { fr: "TVQ", en: "QST", rate: 0.09975 }] },
  { code: "ON", fr: "Ontario", en: "Ontario", taxes: [{ fr: "TVH", en: "HST", rate: 0.13 }] },
  { code: "BC", fr: "Colombie-Britannique", en: "British Columbia", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }, { fr: "TVP", en: "PST", rate: 0.07 }] },
  { code: "AB", fr: "Alberta", en: "Alberta", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }] },
  { code: "MB", fr: "Manitoba", en: "Manitoba", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }, { fr: "TVR", en: "RST", rate: 0.07 }] },
  { code: "SK", fr: "Saskatchewan", en: "Saskatchewan", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }, { fr: "TVP", en: "PST", rate: 0.06 }] },
  { code: "NS", fr: "Nouvelle-Écosse", en: "Nova Scotia", taxes: [{ fr: "TVH", en: "HST", rate: 0.14 }] },
  { code: "NB", fr: "Nouveau-Brunswick", en: "New Brunswick", taxes: [{ fr: "TVH", en: "HST", rate: 0.15 }] },
  { code: "NL", fr: "Terre-Neuve-et-Labrador", en: "Newfoundland and Labrador", taxes: [{ fr: "TVH", en: "HST", rate: 0.15 }] },
  { code: "PE", fr: "Île-du-Prince-Édouard", en: "Prince Edward Island", taxes: [{ fr: "TVH", en: "HST", rate: 0.15 }] },
  { code: "NT", fr: "Territoires du Nord-Ouest", en: "Northwest Territories", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }] },
  { code: "NU", fr: "Nunavut", en: "Nunavut", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }] },
  { code: "YT", fr: "Yukon", en: "Yukon", taxes: [{ fr: "TPS", en: "GST", rate: 0.05 }] },
];

// Miroir du calcul serveur (arrondi au cent par taxe, demi-cent supérieur)
export const computeTaxes = (subtotal, provinceCode, lang = "fr") => {
  const prov = PROVINCES.find((p) => p.code === provinceCode);
  if (!prov) return { lines: [], total: 0 };
  const lines = prov.taxes.map((tx) => ({
    label: lang === "en" ? tx.en : tx.fr,
    rate: tx.rate,
    amount: Math.round(subtotal * tx.rate * 100) / 100,
  }));
  return { lines, total: lines.reduce((s, l) => s + l.amount, 0) };
};

export const fmtRate = (rate) =>
  `${(rate * 100).toFixed(3).replace(/0+$/, "").replace(/[.,]$/, "").replace(".", ",")} %`;
